
import { FIREARM_ASSIGNMENT_LOG_METADATA } from './firearm-assignment-log.metadata';
import { FirearmAssignmentLogBase } from './firearm-assignment-log.model.base';
import { CrudEntity, CrudEntityConstructionOptions } from '@scisys-uim/uim-common';


export interface FirearmAssignmentLog extends FirearmAssignmentLogBase {
}

export interface FirearmAssignmentLogTransient { }

export class FirearmAssignmentLog extends CrudEntity<FirearmAssignmentLog, number, FirearmAssignmentLogTransient> implements FirearmAssignmentLogTransient {
  constructor(source?: Partial<FirearmAssignmentLog>, options?: CrudEntityConstructionOptions<FirearmAssignmentLog, number, FirearmAssignmentLogTransient>) {
    super(FIREARM_ASSIGNMENT_LOG_METADATA, source, options);
  }
  
  initialiseEntityDefaults() {
    super.initialiseEntityDefaults();
  }
  
  registerPropertyCalculators() {
    super.registerPropertyCalculators();
  }

  getCurrentAssignment() {
    return this.assignments?.find(a=>a.firearmAssignmentId == this.currentAssignmentId);
  }
}





